import store from '@store/index'

function AuthGuard(to, from, next) {
  const user = store.getters['auth/user']
  if (user) {
    if (user.role === 'Admin') next({ name: 'admin.agencies.index' })
    else if (user.role === 'Agency') {
      // if (user.hasCourses) {
      //   next({ name: 'agency.courses.index' })
      // } else {
        next({ name: 'agency.websites.index' })
      // }
    } else if (['AgencyUser', 'WebsiteUser'].includes(user.role)) {
      next({ name: 'agency.websites.index' })
    } else if (['CardUser'].includes(user.role)) {
      next({ name: 'user.cards.index' })
    }
  } else next()
}

export default AuthGuard